<template>
  <section class="box" style="margin-top: 1.5rem">
    <h2 class="title is-6">{{ lang('Security settings') }}</h2>

    <div class="field">
      <label class="label">{{ lang('Idle logout minutes') }}</label>
      <div class="field is-grouped">
        <div class="control">
          <input
            class="input"
            type="number"
            min="1"
            max="120"
            step="1"
            style="width: 10rem"
            v-model.number="idleMinutes"
            :disabled="loading"
          >
        </div>
        <div class="control">
          <span class="button is-static">{{ lang('Minutes') }}</span>
        </div>
      </div>
      <p class="help">{{ lang('Idle logout minutes help') }}</p>
    </div>

    <div class="field">
      <label class="label">{{ lang('Download link lifetime minutes') }}</label>
      <div class="field is-grouped">
        <div class="control">
          <input
            class="input"
            type="number"
            min="1"
            max="1440"
            step="1"
            style="width: 10rem"
            v-model.number="linkMinutes"
            :disabled="loading"
          >
        </div>
        <div class="control">
          <span class="button is-static">{{ lang('Minutes') }}</span>
        </div>
      </div>
      <p class="help">{{ lang('Download link lifetime help') }}</p>
    </div>

    <div class="field">
      <b-checkbox v-model="ipLock" :disabled="loading">{{ lang('Lock download link to IP') }}</b-checkbox>
    </div>

    <div class="field">
      <button
        class="button is-primary"
        :class="{ 'is-loading': saving }"
        :disabled="loading"
        @click="save"
      >{{ lang('Save') }}</button>
    </div>
  </section>
</template>

<script>
import api from '../../api/api'

export default {
  name: 'SettingsSecurity',
  data() {
    return {
      idleMinutes: 10,
      linkMinutes: 240,
      ipLock: true,
      loading: true,
      saving: false,
    }
  },
  mounted() {
    api.getSettings()
      .then(ret => {
        this.idleMinutes = ret.idle_logout_minutes
        this.linkMinutes = ret.download_link_lifetime_minutes
        this.ipLock = ret.download_link_ip_lock
        this.loading = false
      })
      .catch(error => {
        this.loading = false
        this.handleError(error)
      })
  },
  methods: {
    save() {
      if (!this.idleMinutes || this.idleMinutes < 1 || this.idleMinutes > 120) {
        this.$toast.open({
          message: this.lang('Idle logout minutes help'),
          type: 'is-danger',
        })
        return
      }
      if (!this.linkMinutes || this.linkMinutes < 1 || this.linkMinutes > 1440) {
        this.$toast.open({
          message: this.lang('Download link lifetime help'),
          type: 'is-danger',
        })
        return
      }
      this.saving = true
      api.saveSettings({
        idle_logout_minutes: this.idleMinutes,
        download_link_lifetime_minutes: this.linkMinutes,
        download_link_ip_lock: this.ipLock,
      })
        .then(ret => {
          this.saving = false
          // Cap nhat luon cau hinh dang nap trong trinh duyet, giong
          // SettingsUpload.vue - phut tu-out co hieu luc ngay khong can F5.
          this.$store.state.config.idle_logout_minutes = ret.idle_logout_minutes
          this.$toast.open({
            message: this.lang('Updated'),
            type: 'is-success',
          })
        })
        .catch(error => {
          this.saving = false
          this.handleError(error)
        })
    },
  },
}
</script>
